import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "19",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m19.74 16.548-1.983-3a9.3 9.3 0 0 0 .973-4.157c0-5.174-4.2-9.374-9.365-9.374a9.28 9.28 0 0 0-6.617 2.748A9.33 9.33 0 0 0 0 9.383c0 5.165 4.2 9.365 9.365 9.365a9.4 9.4 0 0 0 4.679-1.252l3.852 1.39c.174.062.348.097.53.097.487 0 .93-.218 1.235-.6.417-.53.452-1.27.078-1.835m-2.392.009-3.565-1.287-.183.13a7.3 7.3 0 0 1-4.235 1.34C5.305 16.74 2 13.434 2 9.373s3.304-7.348 7.365-7.348S16.73 5.33 16.73 9.391a7.3 7.3 0 0 1-1.182 3.983l-.157.235 1.948 2.948z"
    }, null, -1)
  ])))
}
export default { render: render }